module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M29 6H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-2-6H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM0 13v18a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1zm22 11H10a2 2 0 0 1-2-2v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/files-1.js
// module id = 1146
// module chunks = 14